import fetchJson from './fetch-json';
import CalculateRequestDataworker from '@/workers/CalculateRequestData.worker.js';
import { funcReplacer } from '../../helpers/main_helper';

export default class {
  url = '';
  targetElement;
  buttonElement;
  areaId;
  VueLoadingProcess = false;
  VueErrorHandler = false;
  aggregateInterval = {};
  templateName;
  interval;
  callback;
  isGetSmenas = false;
  smenasOrigin = [];
  params = null;
  isInfoOnAreaId = true;

  constructor({
    url,
    targetElement,
    buttonElement,
    areaId,
    VueLoadingProcess,
    VueErrorHandler,
    aggregateInterval,
    shiftWorkWorkerData,
    templateName,
    interval,
    callback,
    isGetSmenas = false,
    smenasOrigin = [],
    params = null,
    isInfoOnAreaId = true,
  } = {}) {
    this.url = url;
    this.isInfoOnAreaId = isInfoOnAreaId;
    this.shiftWorkWorkerData = shiftWorkWorkerData;

    this.targetElement = targetElement;
    this.buttonElement = buttonElement;
    this.areaId = areaId;

    this.VueLoadingProcess = VueLoadingProcess;
    this.VueErrorHandler = VueErrorHandler;

    this.aggregateInterval = aggregateInterval;
    this.templateName = templateName;
    this.interval = interval;
    this.callback = callback;
    this.isGetSmenas = isGetSmenas;
    this.smenasOrigin = smenasOrigin;
    this.params = params;

    this.hostname = location.hostname;
    this.protocol = location.protocol;
  }

  async getDataAndCalculate(objIdArr, dataSend) {
    this.objIdArr = objIdArr;
    infoShowText_helper(this.targetElement, `Отправляю запрос...`, this.isInfoOnAreaId ? this.areaId : null);
    try {
      return await this.getDataStepByStep(objIdArr, dataSend);
    } catch (e) {
      console.error(e);
      this.VueErrorHandler('Ошибка получения данных. Выполните новый запрос');
      return { error: 'Ошибка получения данных с сервера', errorText: 'Ошибка получения данных. Выполните новый запрос' };
    }
  }

  async getDataStepByStep(objIdArr, dataSend) {
    const queryCount = objIdArr.length;
    let expectedObjectsCount = 0;
    const resultArray = [];
    const resultObject = {
      objects: [],
      rows_summ: {
        header: [],
        lines: [[]],
        settingsSumm: [],
      },
      rows_summ_forGraph_100: {
        header: [],
        lines: [[]],
        settingsSumm: [],
      },
      format: null,
      objectIdsNotIncludesInRequest: [],
    };

    const worker = new CalculateRequestDataworker();

    worker.addEventListener('message', (event) => {
      const {
        object,
        rows_summ,
        rows_summ_forGraph_100,
        format,
        objectIdsNotIncludesInRequest,
      } = event.data;

      resultObject.objects.push(object);

      resultObject.rows_summ.header = rows_summ.header;
      resultObject.rows_summ.lines[0].push(
        rows_summ.lines[0][rows_summ.lines[0].length - 1],
      );
      resultObject.rows_summ.settingsSumm = rows_summ.settingsSumm;

      resultObject.rows_summ_forGraph_100.header =
        rows_summ_forGraph_100.header;
      resultObject.rows_summ_forGraph_100.lines = rows_summ_forGraph_100.lines;

      resultObject.rows_summ_forGraph_100.settingsSumm =
        rows_summ_forGraph_100.settingsSumm;

      resultObject.objectIdsNotIncludesInRequest.concat(
        objectIdsNotIncludesInRequest,
      );

      resultObject.format = format;
    });

    worker.addEventListener('error', (error) => {
      console.error(error.message);
    });

    // есть queriesData
    // нужно создать сначала 10 fetch запросов
    // потом при ответе на один запрос создавать еще запрос
    // так до тех пор, пока все запросы не закончатся
    // а если один из них завершится ошикой, то и другие не создавать

    const fetcher = {
      isError: false,
      isDone: false,
      queryCount,
      queryIndex: 0,
      sendedCount: 0,
      responsesCount: 0,
      progressCount: 0,
      maxTogetherCount: 8,
      maxQueryCount: 3,
      checkAndGetFetch: async (fetcher, resolve, reject) => {
      const {
        queriesData,
        queryCount,
        sendedCount,
        responsesCount,
        maxTogetherCount,
        maxQueryCount,
        isError,
      } = fetcher;
      if (isError) {
        reject();
        worker.terminate();
        return;
      }
      if (responsesCount === queryCount) {
        fetcher.isDone = true;
        if (
          [
              'skillsMan',
              'drivingSafety',
              'vehicleEfficiency',
              'getCalculated',
              'criticalViolations',
              'getCalculatedWithGeofences',
              // 'regularMovingGeoTemplate',
              'evacuatorMoving',
            ].includes(this.templateName)
          ) {
            while (resultObject.objects.length !== expectedObjectsCount) {
              await new Promise((res) => setTimeout(res, 500));
            }
            resultObject.format = formatToDisplay_helper;
            resultObject.objects = resultObject.objects.sort((a, b) => a.id.localeCompare(b.id));
            resolve(resultObject);
          } else {
            resultArray.sort((a, b) => a.id.localeCompare(b.id));
            resolve(resultArray);
          }

          worker.terminate();
          return;
        }
        if (
          sendedCount - responsesCount < maxTogetherCount &&
          sendedCount < objIdArr.length
        ) {
          const queryData = queriesData[sendedCount];
          fetcher.sendedCount++;
          if (queryData.isGetFlag) {
            try {
              this.requestRetry(
                { url: queryData['url'], id: queryData['id'], maxQueryCount },
                fetcher,
              )
                .then((res) => {
                  // при выполеннии одного из запросов

                  if (
                    [
                      'skillsMan',
                      'drivingSafety',
                      'vehicleEfficiency',
                      'getCalculated',
                      'criticalViolations',
                      'getCalculatedWithGeofences',
                      // 'regularMovingGeoTemplate',
                      'evacuatorMoving',
                    ].includes(this.templateName)
                  ) {
                    if (this.templateName === 'vehicleEfficiency') {
                      let objectsCount = 1;
                      try {
                        const json = JSON.parse(res.data);
                        objectsCount = Array.isArray(json) ? json.length : 1;
                      } catch (e) {
                        console.error(e);
                      }
                      expectedObjectsCount += objectsCount;
                    } else {
                      expectedObjectsCount += 1;
                    }

                    const jsonParams = JSON.stringify(
                      JSON.decycle(this.params),
                    );
                    const jsonSmenasOrigin = JSON.stringify(
                      JSON.decycle(this.smenasOrigin),
                    );

                    worker.postMessage({
                      templateName: this.templateName,
                      data: {
                        i: responsesCount,
                        object: res,
                        aggregateInterval: this.aggregateInterval,
                        isGetSmenas: this.isGetSmenas,
                        jsonSmenasOrigin,
                        jsonParams,
                      },
                    });
                  } else {
                    resultArray.push(res);
                  }

                  fetcher.responsesCount++;
                  fetcher.checkAndGetFetch(fetcher, resolve, reject);
                })
                .catch((e) => {
                  console.error(e);
                  fetcher.isError = true;
                  fetcher.errorMessage = e.message || 'Неизвестная ошибка';
                  reject(e);
                });
            } catch (error) {
              fetcher.isError = true;
              reject(error);
            }
          } else {
            fetcher.responsesCount++;
          }
          // и при добавлении одного запроса
          fetcher.checkAndGetFetch(fetcher, resolve, reject);
        }
      },
      };

    fetcher.queriesData = this.queriesPrepare(objIdArr, dataSend);

    const result = await new Promise((resolve, reject) => {
      fetcher.checkAndGetFetch(fetcher, resolve, reject);
    });
    return result;
  }

  async getData({ url, id } = {}, fetcher) {
    return new Promise((resolve, reject) => {
      try {
        fetchJson(url, {})
          .then((response) => {
            return JSON.stringify(response);
          })
          .then((REPORT) => {
            const { queryCount } = fetcher;
            fetcher.progressCount++;
            const percent = Math.round(
              (100 * fetcher.progressCount) / queryCount,
            );

            if (this.VueLoadingProcess) {
              this.VueLoadingProcess(
                `Загружено ${fetcher.progressCount} из ${queryCount} (${percent}%)`,
              );
            } else {
              infoShowText_helper(
                this.targetElement,
                `Получен ответ ${
                  fetcher.progressCount
                } из ${queryCount} (${percent}%)`,
                this.isInfoOnAreaId ? this.areaId : null,
              );
            }
            
            resolve({ id, data: REPORT });
          })
          .catch((error) => {
            console.error(error);
            reject();
            throw error;
          });
      } catch (error) {
        console.error(error);
        reject();
      }
    });
  }

  async requestRetry({ url, id, maxQueryCount }, fetcher) {
    try {
      // Имитация ошибки для последнего ТС в vehicle_dashboard
      // const isLastObject = fetcher.sendedCount === fetcher.queryCount;
      // if (this.templateName === 'vehicle_dashboard' && isLastObject) {
      //   console.warn(`[TEST] Имитация ошибки для последнего ТС (id: ${id})`);
      //   throw new Error(`Ошибка при запросе данных для ТС №${id}. Сервер недоступен.`);
      // }

      return await this.getData({ url, id }, fetcher);
    } catch (error) {
      if (maxQueryCount < 1) throw error;

      maxQueryCount--;
      return await this.requestRetry({ url, id, maxQueryCount }, fetcher);
    }
  }

  queriesPrepare(objIdArr, dataSend) {
    const { hostname, protocol } = this;

    try {
      return objIdArr.map((id, index) => {
        let url = this.url;

        const objId = `?id=${id}`;
        const keys = Object.keys(dataSend);

        let searchParams = '';

        for (let i = 0; i < keys.length; i++) {
          if (!dataSend[keys[i]]) continue;

          if (typeof dataSend[keys[i]] === 'object') {
            dataSend[keys[i]].map((val) => {
              searchParams += `&${keys[i]}%5B%5D=${val}`;
            });
            continue;
          }

          searchParams += `&${keys[i]}=${dataSend[keys[i]]}`;
        }

        const tzh = 0 - new Date().getTimezoneOffset() / 60;
        searchParams += `&tzh=${tzh}`;

        return {
          isGetFlag: true,
          errorIndex: 0,
          id,
          url: `${url}${objId}${searchParams}`,
        };
      });
    } catch (e) {
      console.error(e);
    }
  }
}
